import { useIsAuthenticated } from "@azure/msal-react"
import { Navigate, Outlet, useLocation } from "react-router-dom"

interface ProtectedRouteProps {
  children?: React.ReactNode
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const isAuthenticated = useIsAuthenticated()
  const location = useLocation()

  // Skip auth check in development if REACT_APP_SKIP_AUTH is true
  if (
    process.env.NODE_ENV === "development" &&
    process.env.REACT_APP_SKIP_AUTH === "true"
  ) {
    console.log("ProtectedRoute: Skipping auth")
    return children ? <>{children}</> : <Outlet />
  }

  if (!isAuthenticated) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  return children ? <>{children}</> : <Outlet />
}
